import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { riverCardMotion } from './motion';
import { riverChromeTone } from './palette';

export const riverTheme: FlowThemeDefinition = {
  id: 'river',
  label: 'River Journey',
  description: 'Paddle a canoe downstream past reeds, a stone bridge and a waterfall, one stretch per answer, out onto a sunlit lake.',
  category: 'daylight',
  chromeTone: riverChromeTone,
  swatch: 'linear-gradient(170deg, #7DB8EA 0%, #E6F2F2 40%, #5A9460 58%, #7FBCD6 75%, #2E6E8C 100%)',
  cardGlass: 'default',
  cardMotion: riverCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createRiverScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
